import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export default class CreditCard {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  number!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsString()
  @Expose()
  registerSymbol!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  disableExport!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
}

export class CreditCardAddEdit {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
  @IsString()
  @Expose()
  number!: string;
  @IsString()
  @Expose()
  currency!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: string | null;
  @IsString()
  @Expose()
  registerSymbol!: string;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
  @IsBoolean()
  @Expose()
  disableExport!: boolean;

  constructor() {
    this.id = 0;
    this.name = "";
    this.number = "";
    this.currency = "";
    this.description = "";
    this.registerSymbol = "";
    this.isLocked = false;
    this.disableExport = false;
  }
}
